import React from 'react';

/**
 * Unified color palette component for text color selection
 * Uses 15 distinctly different soft, muted colors consistent across the entire app
 */
export const ColorPalette = ({
  selectedColor,
  onSelectColor,
  size = 'w-8 h-8',
}) => {
  // 15 well-differentiated soft, muted colors across the color spectrum
  const softColors = [
    '#D9716D', // muted coral/salmon
    '#6FB3A8', // muted teal
    '#B89AC8', // muted lavender
    '#E8C455', // muted gold
    '#9DB887', // muted sage green
    '#C89697', // muted rose/mauve
    '#8BA9C8', // muted steel blue
    '#D4A87A', // muted caramel/tan
    '#B3D4A0', // muted pistachio green
    '#D4A8C8', // muted lilac
    '#9EBDD4', // muted periwinkle
    '#C8B89D', // muted taupe
    '#8FD4A8', // muted mint green
    '#E8B89D', // muted peach
    '#7ABFD4', // muted cool blue
  ];

  return (
    <div className="inline-flex flex-wrap gap-1 justify-center">
      {softColors.map(color => (
        <button
          key={color}
          type="button"
          onClick={() => onSelectColor(color)}
          className={`${size} rounded-full border-2 transition-all hover:scale-110 ${
            selectedColor === color
              ? 'border-gold ring-2 ring-gold/60 scale-110'
              : 'border-white/20 hover:border-gold/40'
          }`}
          style={{
            backgroundColor: color,
            boxShadow: selectedColor === color
              ? `0 8px 24px ${color}50, inset 0 1px 2px rgba(255,255,255,0.4)`
              : `0 2px 6px ${color}30`
          }}
          title={color}
        />
      ))}
    </div>
  );
};
